/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { useState } from 'react';
import styled from 'styled-components';
import BSGLOGO from '../../assets/icons/BSG.png';
import Logout from '../Logout';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../Routes';
import { toast } from 'react-toastify';

const HeaderContainer = styled.header`
  background-color: #53a8a0;
  display: flex;
  align-items: center;
  display: flex;
  height: 80px;
  @media (max-width: 767px) {
    flex-direction: column;
    height: auto;
    padding: 10px;
  }
`;

const Logo = styled.img`
  width: 50px;
  height: 50px;
`;

const LogoContainer = styled.div`
  width: 12%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    align-items: flex-start;
    justify-content: flex-start;
    width: -webkit-fill-available;
  }
`;

const ProfileLogoContainer = styled.div`
  ${LogoContainer};
  @media (max-width: 767px) {
    display: none;
  }
`;

const ProfileLogoContainerMobile = styled.div`
  ${LogoContainer};
  display: none;
  @media (max-width: 767px) {
    display: block;
    align-items: flex-start;
    justify-content: flex-start;
    width: -webkit-fill-available;
  }
`;

const Tabs = styled.div`
  display: flex;
  width: 75%;
  @media (max-width: 767px) {
    flex-direction: column;
    width: 100%;
    display: ${({ showMenu }) => (showMenu ? 'flex' : 'none')};
  }
`;

const Tab = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  margin-right: 55px;
  color: #ffffff;
  cursor: pointer;
  @media (max-width: 767px) {
    margin-right: 30px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
`;

const HamburgerIcon = styled.div`
  display: none;
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
  @media (max-width: 767px) {
    display: block;
    margin-left: auto;
    margin-right: 10px;
  }
`;

const Header = () => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const handleHome = () => {
    navigate(ROUTES.HOME);
    setShowMenu(false);
  };

  const handleContribution = () => {
    const isContributionEnabled =
      process.env.REACT_APP_CONTRIBUTION_ENABLED === 'true';

    if (isContributionEnabled) {
      navigate(ROUTES.CONTRIBUTION_FIRST_PAGE);
    } else {
      toast.error('Contribution is not Enabled', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
    }
    setShowMenu(false);
  };

  const handleHistory = () => {
    navigate(ROUTES.CONTRIBUTION_HISTORY_PAGE);
    setShowMenu(false);
  };

  const handleForm10BE = () => {
    navigate(ROUTES.FORM_10_BE_LISTING);
    setShowMenu(false);
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <HeaderContainer>
      <LogoContainer>
        <Logo src={BSGLOGO} alt="Logo" />
        <HamburgerIcon onClick={toggleMenu}>
          {showMenu ? 'X' : '☰'}
        </HamburgerIcon>
      </LogoContainer>
      <Tabs showMenu={showMenu}>
        <Tab onClick={handleHome}>HOME</Tab>
        <Tab onClick={handleContribution}>MAKE CONTRIBUTION</Tab>
        <Tab onClick={handleHistory}>CONTRIBUTION HISTORY</Tab>
        <Tab onClick={handleForm10BE}>F0RM 10BE</Tab>
        <ProfileLogoContainerMobile>
          <Logout />
        </ProfileLogoContainerMobile>
      </Tabs>
      <ProfileLogoContainer>
        <Logout />
      </ProfileLogoContainer>
    </HeaderContainer>
  );
};

export default Header;
